<template>
  <el-dialog
    v-if="formData"
    :visible.sync="dialogVisible"
    custom-class="form-dialog"
    append-to-body
    :title="
      formData.id ? '编辑图片' : $t('shopDecoration.multimediaMaterial.upload')
    "
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="分组" prop="meterialGroupId">
        <!-- <el-select v-model="formData.meterialGroupId" >
          <el-option
            v-for="item in groupsList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-cascader
          v-model="saveGroupId"
          placeholder="请选择商品分组"
          :options="groupsList"
          :props="{
            value: 'id',
            label: 'groupName',
            children: 'children',
            checkStrictly: true,
          }"
          clearable
          filterable
        >
          <template slot-scope="{ node, data }">
            <div class="cascader-view">{{ data.groupName }}</div>
            <!-- <dic v-if="!node.isLeaf">({{ data.children.length }})</dic> -->
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item v-if="formData.id" label="标题" prop="materialName">
        <el-input
          v-model="formData.materialName"
          :maxlength="15"
          show-word-limit
        >
          <template slot="append">{{ tempType }}</template>
        </el-input>
      </el-form-item>

      <el-form-item v-show="!formData.id" label="">
        <el-upload
          :file-list="fileList"
          :action="actionUrlCustom"
          :headers="uploadHeaders"
          multiple
          drag
          :accept="acceptByType"
          :limit="limit"
          :on-exceed="handleExceed"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeFileUpload"
          :before-remove="beforeRemove"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          list-type="picture-card"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            <p>
              注意：
              <br />
              <span>
                1. 图片上传支持bmp、png、jpg、jpeg、gif格式；
              </span>
              <br />
              <span>
                2. 则最大支持5M的图片；
              </span>
              <br />
              <span>
                3. 最多上传50张图片；
              </span>
            </p>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">
        {{ $t('shopDecoration.home.controls.cancel') }}
      </el-button>
      <el-button type="primary" @click="confirm">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import editDialog from '@/mixins/edit-dialog';
import elUpload from '@/mixins/el-upload';
import { mapGetters } from 'vuex';

export default {
  components: {},
  mixins: [editDialog, elUpload],
  props: {
    editItem: {
      type: Object,
      required: true,
    },
    groupsList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['sellerBookingType', 'yyStoreId']),
    requestPre() {
      return this.sellerBookingType === 1 ? '/bookingAdmin' : '';
    },
  },
  data() {
    return {
      actionUrlCustom:
        this.$http.defaults.baseURL + '/business/common/file/uploadPandV',
      limit: 1,
      maxFileSize: 5,
      customAccept: ['bmp', 'png', 'jpg', 'gif', 'jpeg'],
      formData: null,
      saveGroupId: [],
      rules: {
        meterialGroupId: {
          required: true,
        },
        // materialName: {
        //   type: 'string',
        //   required: true,
        //   message: this.$t(
        //     'shopDecoration.multimediaMaterial.materialNameRequired'
        //   ),
        // },
        // fileList: {
        //   type: 'array',
        //   required: true,
        // message: this.$t('shopDecoration.multimediaMaterial.fileRequired'),
        // },
      },
    };
  },
  watch: {
    dialogVisible(v) {
      if (!v) this.fileList = [];
    },
    editItem: {
      handler(v) {
        this.formData = _.cloneDeep(v);
        // children

        const findTree = (val, arr) => {
          if (val.id == 0) {
            return [];
          }
          if (this.formData.meterialGroupId == val.id) {
            return [...arr, val.id];
          }
          if (val.children !== null) {
            for (const v of val.children) {
              return findTree(v, [...arr, val.id]);
            }
          } else {
            return [];
          }
        };
        if (this.groupsList.length > 0) {
          for (const val of this.groupsList) {
            const fin = findTree(val, []);
            if (fin.length > 0) {
              this.saveGroupId = fin;
              break;
            }
          }
        }

        // 回显
        if (this.formData.id) {
          // 处理name
          if (
            this.formData.materialName &&
            this.formData.materialName.includes('.')
          ) {
            const res = this.formData.materialName.match(/(.*)\.(.+)/);
            this.formData.materialName = res[1];
            this.tempType = '.' + res[2];
          } else {
            // old data
            this.tempType = '.' + this.formData.fileName.match(/.*\.(.+)/)[1];
          }
          this.limit = 1;
          this.fileList = [
            {
              name: this.formData.fileName,
              url: this.imageUrl + this.formData.pictureUrl,
            },
          ];
        } else {
          this.tempType = '';
          this.limit = 50;
        }
      },
      immediate: true,
    },
  },
  methods: {
    confirm() {
      // this.formData.meterialGroupId = this.formData.meterialGroupId[
      //   this.formData.meterialGroupId.length - 1
      // ];

      if (Array.isArray(this.saveGroupId) && this.saveGroupId.length > 0) {
        this.formData.meterialGroupId = this.saveGroupId[
          this.saveGroupId.length - 1
        ];
      }
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const file = this.fileList[0];
        if (!file) {
          this.$message.info(
            this.$t('shopDecoration.multimediaMaterial.fileRequired')
          );
          return;
        }
        // 图片 response > old

        const url = this.formData.id
          ? `${this.requestPre}/sellerMaterial/update`
          : `${this.requestPre}/sellerMaterial/save`;

        let params;
        if (this.formData.id) {
          let fileParams = {};
          if (file.response) {
            fileParams = {
              fileName: file.name,
              materialSize: file.size,
              pictureUrl: file.response.data.pictureUrl,
              originPictureUrl: file.response.data.originPictureUrl,
              width: file.response.data.width,
              height: file.response.data.height,
            };
          }

          const originParams = {
            ...this.formData,
            ...fileParams,
            materialName: this.formData.materialName
              ? this.formData.materialName + this.tempType
              : '',
            type: CONST.MATERIAL_TYPE.img,
          };
          params = {
            sellerMaterialList: [originParams],
          };
        } else {
          // 新增可批量
          params = this.fileList.map(file => {
            // 处理文件名
            // /.*\.(.+)/ 'a.b.c.d' => .d
            let materialName = '';
            const res = file.name.match(/(.*)\.(.+)/);
            materialName = res[1].slice(0, 15) + '.' + res[2];
            return {
              ...this.formData,
              materialName,
              fileName: file.name,
              materialSize: file.size,
              pictureUrl: file.response.data.pictureUrl,
              originPictureUrl: file.response.data.originPictureUrl,
              width: file.response.data.width,
              height: file.response.data.height,
              type: CONST.MATERIAL_TYPE.img,
            };
          });
        }

        this.$http
          .post(url, params, {
            showLoading: true,
          })
          .then(res => {
            if (res.data.success) {
              this.$message.success('保存成功！');
              this.close();
              this.$emit('edited', {
                meterialGroupId: this.formData.meterialGroupId,
              });
            } else {
              this.$message.warning(res.data.message);
            }
          });
      });
    },
    handleEditedShop() {
      this.$emit('edited');
    },
  },
};
</script>
<style scoped>
::v-deep .el-upload-dragger {
  width: 146px;
  height: 148px;
}

.el-upload-dragger ::v-deep {
  width: 146px;
  height: 148px;
}
</style>

<style lang="scss" scoped>
.upload-demo {
  ::v-deep .el-upload-dragger {
    width: 146px;
    height: 148px;
  }
}
::v-deep .el-upload-dragger {
  width: 146px;
  height: 148px;
}
</style>
